import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Col, Modal, Row, Space } from 'antd'
import Title from 'Components/text/Title'
import { PrimaryButton } from 'Components/button'
import { MyTheme } from 'Components/common/Theme'
import Label from 'Components/text/Label'
import Dragger from 'antd/lib/upload/Dragger'
import { DownloadOutlined, InboxOutlined } from '@ant-design/icons'
import { RcFile } from 'antd/lib/upload'
import { currentDateImport } from 'helpers/format'
import downloadCSVFile, { downloadUnicodeCSVFile } from 'helpers/export'

interface Props {
  isShow: boolean
  handleOk?: (file: any) => void
  handleCancel?: () => void
  title?: string
  titleSecond?: string
  confirmBtnTxt?: string
  cancelBtnTxt?: string
  loading?: boolean
  description?: string
  mid?: number
}

const ConfirmImport = (props: Props) => {
  const {
    isShow = false,
    handleOk = () => {},
    handleCancel = () => {},
    title = 'ยืนยันการนำเช้า',
    confirmBtnTxt = 'ลบ',
    cancelBtnTxt = 'ยกเลิก',
    loading = false,
    description = '',
    titleSecond = '',
    mid = 0,
  } = props

  const [fileAttach, setFileAttach] = useState([] as any[])

  useEffect(() => {
    return () => {
      setFileAttach([])
    }
  }, [isShow])

  const onSubmit = () => {
    handleOk(fileAttach[0])
  }

  const footer = (
    <FooterStyled>
      <Row justify="center" gutter={16}>
        <Col md={8} xs={10}>
          <PrimaryButton text={cancelBtnTxt} btnType="Cancel" onClick={handleCancel} />
        </Col>
        <Col md={8} xs={10}>
          <PrimaryButton
            text={confirmBtnTxt}
            onClick={onSubmit}
            loading={loading}
            disabled={fileAttach.length < 1}
          />
        </Col>
      </Row>
    </FooterStyled>
  )

  const uploadProps = {
    name: 'file',
    multiple: false,
    accept: '.csv',
    beforeUpload: (file: RcFile) => {
      const newFile = [file]
      setFileAttach(newFile)
      return false
    },
    onRemove: () => {
      setFileAttach([])
    },
    fileList: fileAttach,
    onChange() {},
    onDrop() {},
  }

  const onDownload = () => {
    const reportData = `StartDate,EndDate,StartTime,EndTime,Location,StrNo,StrClass,Weight
18/5/2565,18/5/2565,15:36:00,15:41:00,17.0444 - 100.3506,1,Lean (คอนกรีตหยาบ),5410
18/5/2565,18/5/2565,15:42:00,15:43:00,17.0444 - 100.3506,2,180 ksc,1810
18/5/2565,18/5/2565,15:44:00,15:47:00,17.0444 - 100.3506,3,210 ksc,3610
18/5/2565,18/5/2565,15:47:00,15:49:00,17.0444 - 100.3506,4,240 ksc,7210
18/5/2565,18/5/2565,15:49:00,15:50:00,17.0444 - 100.3506,5,280 ksc,1810
`
    const fileName = `(ตัวอย่าง)MINIRMX-${mid}-${currentDateImport()}.csv`
    downloadUnicodeCSVFile(reportData, fileName)
  }

  return (
    <ModalStyled visible={isShow} onCancel={handleCancel} footer={footer} centered>
      <ContentWrapper>
        <Title>{title}</Title>
        {titleSecond && <TitleSecond>{titleSecond}</TitleSecond>}
        <UploadWrapper>
          <Dragger {...uploadProps}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">คลิ๊กหรือลากไฟล์เพื่ออัพโหลด</p>
            <TextStyled>{description}</TextStyled>
          </Dragger>
        </UploadWrapper>

        <DownloadXample onClick={onDownload}>
          <Space>
            <DownloadOutlined />
            ดาวน์โหลดตัวอย่างไฟล์ในการนำเข้า
          </Space>
        </DownloadXample>
      </ContentWrapper>
    </ModalStyled>
  )
}

const ModalStyled = styled(Modal)`
  .ant-modal-content {
    border-radius: 6px;
  }
  .ant-modal-footer {
    border: none;
  }
`

const ContentWrapper = styled.div`
  text-align: center;
`

const FooterStyled = styled.div`
  margin-bottom: 15px;
`

const TextStyled = styled(Label)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  text-align: left;
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`
const UploadWrapper = styled.div`
  padding: 10px 0;
`

const TitleSecond = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.title1};
`

const DownloadXample = styled.div`
  text-align: left;
  cursor: pointer;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

export default ConfirmImport
